export default class AuthHandler {
    public static async handleCrossDomainAuth(): Promise<boolean> {
        return false;
    }
}
